const INITIAL_STATE = {
    motoristas: [],
    motorista: null
  }
  
  export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
      case 'MOTORISTAS_FETCH':
        return { ...state, motoristas: action.payload }
      case 'MOTORISTA_FETCH':
        return { ...state, motorista: action.payload }
      default:
        return state
    }
  }